interface MailToProps {
    email: string;
}

const MailTo: FC<MailToProps> = ({ email }) =>
    email ? (
        <a className="mail-to" href={`mailto:${email}`}>
            {email}
        </a>
    ) : null;

export default MailTo;
